import { NavLink, useParams } from "react-router";
import React, { useState } from 'react';
import Layout from "../components/layout";
import Matrix from "../components/matrix";
import Card from "../components/newComponents/card";
import SectionAreas from "../components/newComponents/sectionAreas";
import SectionHead from "../components/newComponents/sectionHead";
import SectionListing from "../components/newComponents/sectionListing";
import SectionNav from "../components/newComponents/sectionNav";
import SectionRichText from "../components/newComponents/sectionRichText";
import Seo from "../components/seo";
import ProjectList from "../components/newComponents/projectList";
import ImgixFilePreview from "../components/newComponents/ImgixFilePreview";
import YoutubeEmbed from "../components/newComponents/youtubeEmbed";
import GeneralSection from "../components/newComponents/generalSection";
import { CgSoftwareDownload } from 'react-icons/cg';
import StaffList from "../components/newComponents/staffList";
import ImgixFluidImage from "../components/newComponents/ImgixFluidImage";
import { useQuery } from "@apollo/client";
import { HandleQuery, WhatWeDoOverviewData } from "../queries";

export function WhatWeDoOverviewEntry() {

  const [isOpen, setIsOpen] = useState(false);
   
    const { slug } = useParams();

    const query_state = useQuery(WhatWeDoOverviewData(slug), {fetchPolicy: 'no-cache'});
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data; 

  return (
    <Layout>
      <Seo title={data.entry[0].title} />
      <div className="main">
        <GeneralSection className="hero-sm">
        <SectionHead image={data.entry[0].featureImage[0]}/>
            <SectionNav data={data} base={`/what-we-do/${slug}`} currentUri={`/what-we-do/${slug}`} />
        </GeneralSection>
        <GeneralSection className="section-overview">
          <SectionHead title={data.entry[0].title} subtitle={"Overview"}/>
          {data.entry[0].useReadMore ? (isOpen ? <Matrix blocks={data.entry[0].bodyContent} /> : <SectionRichText className="prose max-w-none" richText={data.entry[0].summary}/>) : <Matrix blocks={data.entry[0].bodyContent} />}
          {data.entry[0].bodyContent.length > 0 && !isOpen && data.entry[0].useReadMore && <button className="section__link link-more text-gray-3" onClick={() => setIsOpen(true)}>Read more</button>}
        </GeneralSection>
        {data.entry[0].whatWeDoAdditionalInfo.length > 0 &&
          <GeneralSection className="section-overview">
            <SectionHead subtitle={"Additional info"}/>
            <Matrix blocks={data.entry[0].whatWeDoAdditionalInfo}/>
         </GeneralSection>
        }
        <section>
          <div className="shell">
            <div className="grid grid-cols-1 md:grid-cols-2 grid-rows-2 md:grid-rows-1 gap-2 mb-4">
                {data.entry[0].whatWeDoFeatureVideo.url ? <div><YoutubeEmbed title={data.entry[0].whatWeDoFeatureVideo.title} url={data.entry[0].whatWeDoFeatureVideo.url}/></div> : ''}
                {data.entry[0].whatWeDoBrochureLink &&
                    <figure>
                        <iframe title="Brochure" style={{"border":"1px solid #777"}} src={data.entry[0].whatWeDoBrochureLink} width="100%" height="100%" frameBorder={0} allowFullScreen />
                    </figure>
                }
                {data.entry[0].whatWeDoFeatureBrochure.map((brochure) => (
                  <div className={"relative border-gray-300 border-solid border mx-auto"} style={data.entry[0].whatWeDoBrochureAspectRatio === "portrait" ? { "aspect-ratio": "1/1.4142", "height": "316px" } : null}>
                      <a href={brochure.url} target="_blank" rel="noreferrer">
                        <ImgixFilePreview fileUrl={brochure.url} className={data.entry[0].whatWeDoBrochureAspectRatio === "portrait" ? "aspect-[5/7]" : "aspect-[16/9]"} />
                        <span className="absolute  top-0 left-0 w-full h-full flex justify-center items-center">
                          <CgSoftwareDownload className="w-12 h-12 text-white" style={{filter: "drop-shadow( 3px 3px 5px rgba(0, 0, 0, .9))"}} alt=""/>
                        </span>
                      </a>
                  </div>
                ))}
                {data.entry[0].whatWeDoBrochureLink2 &&
                    <figure>
                        <iframe title="Brochure" style={{"border":"1px solid #777"}} src={data.entry[0].whatWeDoBrochureLink2} width="100%" height="100%" frameBorder={0} allowFullScreen />
                    </figure>
                }
                {data.entry[0].whatWeDoFeatureBrochure2.map((brochure) => (
                  <div className={"relative border-gray-300 border-solid border mx-auto"} style={data.entry[0].whatWeDoBrochureAspectRatio === "portrait" ? { "aspect-ratio": "1/1.4142", "height": "316px" } : null}>
                      <a href={brochure.url} target="_blank" rel="noreferrer">
                        <ImgixFilePreview fileUrl={brochure.url} className={data.entry[0].whatWeDoBrochureAspectRatio === "portrait" ? "aspect-[5/7]" : "aspect-[16/9]"} />
                        <span className="absolute  top-0 left-0 w-full h-full flex justify-center items-center">
                          <CgSoftwareDownload className="w-12 h-12 text-white" style={{filter: "drop-shadow( 3px 3px 5px rgba(0, 0, 0, .9))"}} alt=""/>
                        </span>
                      </a>
                  </div>
                ))}
            </div>
          </div>
        </section>

        {data.entry[0].teamLeads.length > 0 &&
          <SectionListing title={"Leading The Team"} primaryBackground={true} dataId={1}>
            <StaffList staff={data.entry[0].teamLeads.filter((item) => {return item.status == "live"})} keyBase={"team-leads-listing"} />
          </SectionListing>
        }

        {data.entry[0].showCustomBanner &&
          <GeneralSection className="financial-banner py-2">
            <SectionHead subtitle={data.entry[0].customBannerHeadline}/>
            <div className="block md:grid md:grid-cols-2 py-3 items-start md:items-center">
              <div className="border-0 md:border-r-4 financial-banner-line py-4">
                <a href={data.entry[0].customBannerLink} className="section__title title h2 text-gray">{data.entry[0].customBannerRichText}</a>
              </div>
              <a href={data.entry[0].customBannerLink} className="py-4">
                <ImgixFluidImage attribution={data.entry[0].customBannerImage[0].attribution} image={data.entry[0].customBannerImage[0]} sizes="50vw" ar={380/89} focalPoint={data.entry[0].customBannerImage[0].focalPoint}/>
              </a>  
            </div>
          </GeneralSection>
        }

        {data.entry[0].secondaryBannerImage[0] &&
          <GeneralSection className="pb-6">
            <a href={data.entry[0].secondarybannerlink} target="_blank" rel="noreferrer">
              <SectionHead image={data.entry[0].secondaryBannerImage[0]} ar={1486/748}/>
            </a>
          </GeneralSection>
        }

        {(data.entry[0].relatedAreasOfExpertiseFocusAreas.length > 0 || data.entry[0].relatedAreasOfExpertise.length > 0) &&
          <SectionAreas>
            {data.entry[0].relatedAreasOfExpertiseFocusAreas.length > 0 &&
              <div className="boxes swiper-container js-load-more js-slider-boxes-projects">
                <ul>
                  {data.entry[0].relatedAreasOfExpertiseFocusAreas.map((item, i) => (
                    <Card 
                      key={`what-we-do-entry-area-of-expertise-focus-areas-${i}`} 
                      image={item.featureImage[0]} 
                      title={item.displayTitle} 
                      subtitle={item.summary} 
                      href={`/${item.uri}`}
                      color={2}
                    />
                  ))}
                </ul>
                <div className="swiper-pagination boxes__pagination" />
              </div>
            }
            {data.entry[0].relatedAreasOfExpertise.length > 0 && 
              data.entry[0].relatedAreasOfExpertise.map((areaOfExpertise, i) => (
                <li key={`what-we-do-entry-areas-of-expertise-${i}`}>
                  <NavLink to={`/what-we-do/${slug}/areas-of-expertise#id-${areaOfExpertise.slug}`}>{areaOfExpertise.title}</NavLink>
                </li>
              ))
            } 
          </SectionAreas>
        }        

        {data.entry[0].relatedProjects.length > 0 &&
          <SectionListing title={"Projects"} dataId={1} primaryBackground={true} href={data.relatedFocusAreaProjects.length > 0 || data.relatedAreaOfExpertiseProjects.length > 0 ? `/what-we-do/${slug}/projects` : false} hrefLabel={"View all"}>
            <ProjectList projects={data.entry[0].relatedProjects} keyBase="what-we-do-entry-projects"/>
          </SectionListing>
        }

        {data.entry[0].relatedFocusArea.length > 0 &&
          <SectionListing title={"Related Focus Areas"} dataId={1} >
            {data.entry[0].relatedFocusArea.map((focusArea, i) => (
              <Card key={`what-we-do-entry-focus-areas-${i}`} image={focusArea.featureImage[0]} title={focusArea.displayTitle} subtitle={focusArea.summary} href={`/${focusArea.uri}`} color={2}/>
            ))}
          </SectionListing>
        }
      </div>
    </Layout> 
  );
};
